import { Container, Row, Col, Card } from "react-bootstrap";
import { AiOutlineEdit } from "react-icons/ai";
import { MdOutlineEditNote } from "react-icons/md";
import verification from "./../../../public/assets/images/verification.png";
import secure from "./../../../public/assets/images/secure.png";
import edit from "./../../../public/assets/images/edit.png";
import register from "./../../../public/assets/images/register.png";
import { useDispatch, useSelector } from "react-redux";

// import {
//   profile_Info_Title,
//   profile_Info_Reg_que,
//   profile_Info_Reg_ans,
//   profile_Info_User_ans,
//   profile_Info_User_que,
// } from "@/setting";
const ProfileInfo = ({ data, accordianOpen }) => {
  const cmsData = data;
  const profileInfo = useSelector((state) => state.user.profileInfo);

  const navigateToFaq = () => {};

  const isProfileCompleted = () => {
    if (
      profileInfo?.data === null ||
      profileInfo?.data?.userDetails?.address?.address1 === null ||
      profileInfo?.data?.userDetails?.address?.address1?.length === 0 ||
      profileInfo?.data?.userDetails?.address?.city === null ||
      profileInfo?.data?.userDetails?.address?.city?.length === 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {accordianOpen !== 1 ? (
        <Row>
          <Col md={12}>
            <Card className=" profile-faq-card  mb-3 p-2">
              {/* <Card.Header className="profile-faq-card-header">
              <h3 className="text-left">Profile</h3>
            </Card.Header> */}

              <Card.Body className="profile-faq-card-body">
                {/* <p>{cmsData?.profile_Info_Title}</p> */}
                <div className="">
                  <p className="profileHeaderText">Verification</p>
                  <p className="profileBodyText">
                    For more information on the verification process, please see
                    our
                    <a
                      href="/support"
                      target="_blank"
                      className=" linkkk_bid link-offset-2"
                    >
                      {" "}
                      FAQs.
                    </a>
                  </p>
                </div>
                <hr className="profile-faq-divider" />

                <Row>
                  <Col md={6}>
                    <Row className="align-items-center">
                      <Col xs={2}>
                        <img
                          src={secure}
                          alt="register"
                          width={50}
                          height={50}
                        />
                      </Col>
                      <Col xs={10} className="profile-faq-flip-card-inner">
                        <div className="profile-faq-flip-card-front">
                          <h5 className="profileHeaderText">
                            What do you do with the information I enter?
                          </h5>
                        </div>
                        <div className="profile-faq-flip-card-back">
                          <p className="mt-3 profileBodyText">
                            The information is used to verify your identity. We
                            do not store your Social Security number or date of
                            birth in our database, and this information is
                            deleted as soon as your identity is verified.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col md={6}>
                    <Row className="align-items-center">
                      <Col xs={2}>
                        <img
                          src={verification}
                          alt="register"
                          width={50}
                          height={50}
                        />
                      </Col>
                      <Col xs={10} className="profile-faq-flip-card">
                        <div className="profile-faq-flip-card-front">
                          <h5 className="profileHeaderText">
                            Will I have to go through this process every time I
                            log in to Hubzu?
                          </h5>
                        </div>
                        <div className="profile-faq-flip-card-back">
                          <p className="mt-3 profileBodyText">
                            No. This is a one-time verification process. Once
                            your information is verified, you won't be asked to
                            repeat it.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col md={12}>
            <Card className=" profile-faq-card  mb-3 p-2">
              {/* <Card.Header className="profile-faq-card-header">
              <h3 className="text-left">Profile</h3>
            </Card.Header> */}

              <Card.Body className="profile-faq-card-body">
                {/* <p>{cmsData?.profile_Info_Title}</p> */}
                <div className="">
                  <p className="profileHeaderText">Profile</p>
                  <p className="profileBodyText">
                    {cmsData?.profile_Info_Title}
                    <a
                      href="/support"
                      target="_blank"
                      className=" linkkk_bid link-offset-2"
                    >
                      {" "}
                      FAQs.
                    </a>
                  </p>
                </div>
                <hr className="profile-faq-divider" />

                <Row>
                  <Col md={6}>
                    <Row className="align-items-center">
                      <Col xs={2}>
                        <img
                          src={register}
                          alt="register"
                          width={50}
                          height={50}
                        />
                      </Col>
                      <Col xs={10} className="profile-faq-flip-card-inner">
                        <div className="profile-faq-flip-card-front">
                          <h5 className="profileHeaderText">
                            {cmsData?.profile_Info_Reg_que}
                          </h5>
                        </div>
                        <div className="profile-faq-flip-card-back">
                          <p className="mt-3 profileBodyText">
                            {cmsData?.profile_Info_Reg_ans}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col md={6}>
                    <Row className="align-items-center">
                      <Col xs={2}>
                        <img src={edit} alt="register" width={50} height={50} />
                      </Col>
                      <Col xs={10} className="profile-faq-flip-card">
                        <div className="profile-faq-flip-card-front">
                          <h5 className="profileHeaderText">
                            {cmsData?.profile_Info_User_que}
                          </h5>
                        </div>
                        <div className="profile-faq-flip-card-back">
                          <p className="mt-3 profileBodyText">
                            {cmsData?.profile_Info_User_ans}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ProfileInfo;
